<template>
	<view class="box">
		<view class="title">输入自提码</view>
		<view class="input">
			<input type="number" placeholder="请输入6位自提码" />
		</view>
		<view class="btn">确认</view>
		<view class="footer">
			<image src="/pagesA/images/ic_saoma@2x.png" mode="widthFix"></image>
			<text>扫码核销</text>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 100vw;
		height: 100vh;
		display: flex;
		padding-top: 198rpx;
		box-sizing: border-box;
		align-items: center;
		flex-direction: column;
		background: linear-gradient( 180deg, #C8F3FF 0%, #FFFFFF 52.19%, #FFFFFF 100%);
		.title {
			font-weight: 600;
			font-size: 34rpx;
			color: #222222;
		}
		.input {
			width: 630rpx;
			height: 88rpx;
			padding: 0 30rpx;
			box-sizing: border-box;
			background: #FFFFFF;
			border-radius: 50rpx;
			border: 2rpx solid #004096;
			margin-top: 40rpx;
			input {
				width: 100%;
				height: 100%;
				font-weight: 400;
				font-size: 32rpx;
				color: #111111;
				text-align: center;
			}
		}
		.btn {
			width: 630rpx;
			height: 88rpx;
			line-height: 88rpx;
			text-align: center;
			background: #004096;
			border-radius: 44rpx;
			font-weight: 600;
			font-size: 32rpx;
			color: #FFFFFF;
			margin-top: 40rpx;
		}
		.footer {
			display: flex;
			align-items: center;
			margin-top: 48rpx;
			image {
				width: 40rpx;
				height: 40rpx;
				margin-right: 12rpx;
			}
			text {
				font-weight: 400;
				font-size: 28rpx;
				color: #004096;
			}
		}
	}
</style>